import { useState } from "react";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [statusMsg, setStatusMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const hpField = form.querySelector<HTMLInputElement>('[name="website_alt"]');
    if (hpField && hpField.value.trim() !== "") {
      setStatusMsg("Thank you for subscribing!");
      setEmail("");
      setTimeout(() => setStatusMsg(""), 3000);
      return;
    }
    if (!email.trim()) return;

    try {
      const formData = new URLSearchParams();
      formData.append("email", email);
      await fetch("https://readdy.ai/api/form/d8tpaucal24muhn2r9o0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });
      setStatusMsg("Thank you for subscribing!");
      setEmail("");
    } catch {
      setStatusMsg("Thank you for subscribing!");
    }
    setTimeout(() => setStatusMsg(""), 3000);
  };

  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <a href="/" className="text-xl font-bold font-heading text-background-50">
              acbuyspreadsheet<span className="text-accent-500">.blog</span>
            </a>
            <p className="mt-3 text-xs text-background-300 leading-relaxed max-w-xs">
              Your ultimate resource for spreadsheet-based buying strategies, product comparisons, and workflow optimization guides. Updated 2026.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-400 mb-4">Subscribe</h4>
            <form onSubmit={handleSubmit} data-readdy-form className="flex flex-col gap-3">
              <input
                type="text"
                name="website_alt"
                className="hp-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
              />
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="w-full bg-transparent border-0 border-b border-background-500 py-2 text-sm text-background-100 placeholder:text-background-400 focus:outline-none focus:border-accent-400 transition-colors"
              />
              <button
                type="submit"
                className="inline-flex items-center gap-2 text-xs text-accent-400 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
              >
                Subscribe <i className="ri-arrow-right-line"></i>
              </button>
              {statusMsg && (
                <p className="text-xs text-accent-400">{statusMsg}</p>
              )}
            </form>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-400 mb-4">Categories</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 5).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-200 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-400 mb-4">Links</h4>
            <div className="flex flex-col gap-2">
              <a href="/" className="text-sm text-background-200 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">Home</a>
              <a href="/what-is-acbuyspreadsheet" className="text-sm text-background-200 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">What is acbuyspreadsheet</a>
              <a href="/how-acbuyspreadsheet-improves-workflow" className="text-sm text-background-200 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">Workflow Guide</a>
              <a href="/acbuyspreadsheet-vs-traditional-methods" className="text-sm text-background-200 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">Comparison</a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-background-200 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                kaspreadsheet.com
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700/30 py-8 px-4">
        <p className="text-5xl md:text-7xl lg:text-9xl font-extrabold text-background-200/10 text-center tracking-tighter font-heading select-none">
          ACBUY
        </p>
      </div>
    </footer>
  );
}